import { render } from "./NeedMoreCloverPopup.vue?vue&type=template&id=046b4327&scoped=true"
import script from "./NeedMoreCloverPopup.vue?vue&type=script&lang=js"
export * from "./NeedMoreCloverPopup.vue?vue&type=script&lang=js"

import "./NeedMoreCloverPopup.vue?vue&type=style&index=0&id=046b4327&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046b4327"]])

export default __exports__